import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DataService } from 'src/app/shared/data.service';
import { AddEditProposalComponent } from '../add-edit-proposal/add-edit-proposal.component';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { UtilsService } from 'src/app/shared/utils.service';
import { AuthService } from 'src/app/auth/auth.service';
import { User } from 'src/app/auth/user.model';

@Component({
    selector: 'app-value-proposal-details',
    templateUrl: './value-proposal-details.component.html',
    styleUrls: ['./value-proposal-details.component.scss'],
    standalone: false
})
export class ValueProposalDetailsComponent implements OnInit {
  departmentId: any;
  productId: any;
  valueProposalList = new Array<any>();
  departmentName: any;
  selected: any;
  usedOnMobile: any;
  user: User;

  constructor(private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any,
              public utils: UtilsService, private authService: AuthService,
              private router: Router, private dataService: DataService) {
                this.departmentId = data.id;
                this.user = this.authService.getUserData();
                this.departmentName = data.name;
                this.selected = data.selected;
                this.usedOnMobile = data.usedOnMobile;
                this.productId = router.routerState.snapshot.root.children[0].children[0].params.id;
  }

  ngOnInit(): void {
    this.getValueProposals();
  }

  getValueProposals() {
    if (this.usedOnMobile ===  null) {
      this.dataService.get('product/valueProposals/RetrieveValueProposalsByDepartment/' +
      this.productId + '/' + this.departmentId +
      '?AddedBy=2').then((data) => {
        if (data.statusCode === 200) {
          if (this.selected === "usedOnMobile") {
            data.data.records.forEach((item) => {
              if (item.usedOnMobile === true || (item.usedOnMobile === false && item.isAddedByManufacturer === false)) {
                this.valueProposalList.push(item);
              }
            });
          } else {
            this.valueProposalList = data.data.records;
          }
        }
      });
    } else {
      let addedBy = this.usedOnMobile === "true" ? '4' : '2';
      if (this.usedOnMobile === true) {
        addedBy = '4';
      }
      this.dataService.get('product/valueProposals/RetrieveValueProposalsByDepartment/' +
      this.productId + '/' + this.departmentId + '?' +
      '&usedOnMobile=' + this.usedOnMobile +
      '&AddedBy=' + addedBy).then((data) => {
        if (data.statusCode === 200) {
          if (this.selected === "usedOnMobile") {
            data.data.records.forEach((item) => {
              if (item.usedOnMobile === true || (item.usedOnMobile === false && item.isAddedByManufacturer === false)) {
                this.valueProposalList.push(item);
              }
            });
          } else {
            this.valueProposalList = data.data.records;
          }
        }
      });
    }
  }

  moveToUsedOnMobile(id: any) {
    this.dataService.put('product/valueProposals/UpdateUsedOnMobile', {
      valueId : id,
      productId : parseInt(this.productId.toString(), 10),
      usedOnMobile : true
    }).then((data) => {
      if (data.statusCode === 200) {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Success',
            type: 'Success',
            message: 'Used on mobile enabled successfully.',
            buttonText: 'Ok'
          }
        });
        this.getValueProposals();
      }
    });
  }

  moveToNotUsedOnMobile(id: any) {
    this.dataService.put('product/valueProposals/UpdateUsedOnMobile', {
      valueId : id,
      productId : parseInt(this.productId.toString(), 10),
      usedOnMobile : false
    }).then((data) => {
      if (data.statusCode === 200) {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Success',
            type: 'Success',
            message: 'Used on mobile disabled successfully',
            buttonText: 'Ok'
          }
        });
        this.getValueProposals();
      }
    });
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  deleteValueProposal(id: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '400px',
      data: {
        title: 'Delete',
        page: 'proposal',
      }
    });
    dialogRef.afterClosed().subscribe((status) => {
      if (status) {
        if (status === 'accept') {
          this.dataService.delete('product/valueProposals/DeleteValueProposal/' + this.productId + '/' + id).then((data) => {
            if (data.statusCode === 200) {
              this.getValueProposals();
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Success',
                  type: 'Success',
                  message: 'Value proposal deleted successfully',
                  buttonText: 'Ok'
                }
              });
            } else {
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Error',
                  type: 'Error',
                  message: 'Something went wrong, Please try again!',
                  buttonText: 'Ok'
                }
              });
            }
          });
        }
      }
    });
  }

  truncate(string: string) {
    if (string.length  > 32) {
      string = string.slice(0, 32) + '...';
    }
    return string;
  }

  forceDownload(blob, filename) {
    const a = document.createElement('a');
    a.download = filename;
    a.href = blob;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  downloadResource(url, filename) {
    if (!filename) {
      filename = url.split('\\').pop().split('/').pop();
    }
    fetch(url, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/octet-stream'
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.blob();
    })
    .then(blob => {
      const blobUrl = window.URL.createObjectURL(blob);
      this.forceDownload(blobUrl, filename);
    })
    .catch(err => {
      this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Error',
          type: 'Error',
          message: 'Something went wrong, Please try again!',
          buttonText: 'Ok'
        }
      });
    });
  }

  downloadMyFile(url: any, fileName: any) {
    if (url) {
      this.downloadResource(url , fileName);
    }
  }

  editValueProposal(id: any) {
    const dialogRef = this.dialog.open(AddEditProposalComponent, {
      disableClose: true,
      width: '400px',
      data: {
        type: 'Edit',
        id,
      }
    });
    dialogRef.afterClosed().subscribe((editedDepartment) => {
      if (editedDepartment) {
        this.getValueProposals();
      }
    });
  }

  downloadMyFileAndLog(valueProposal: any) {
    if (!valueProposal) return;

    const isValidFile = this.isValidFileExtension(valueProposal.path);
    if (!isValidFile) {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'This is a Link',
          type: 'Info',
          message: 'The selected resource is a link and cannot be downloaded directly.',
          buttonText: 'Ok'
        }
      });
      return;
    }

    this.logMaterial(valueProposal.id);

    this.downloadMyFile(valueProposal.path, valueProposal.fileName);
  }

  logMaterial(id: any) {
    let materialLookup
    let materialId!: number;
    this.dataService.getMaterialTypes().then((data: any) => {
      materialLookup = data;
      for (let index = 0; index < materialLookup.length; index++) {
        const element = materialLookup[index];
        if (element.name === "ProductValueProposalSupportedMaterial") {
          materialId = element.id;
        }
      }
      this.dataService.post('DownloadMaterial/DownloadProductMaterial/' + +materialId + '/' + id, null).then((data) => {
      });

    });
  }

  isValidFileExtension(filePath: string): boolean {
    const allowedExtensions = ['png', 'jpg', 'jpeg', 'txt', 'html', 'pdf', 'rtf', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'];

    const fileExtension = filePath.split('.').pop()?.toLowerCase();

    return allowedExtensions.includes(fileExtension!);
  }
}
